import { CommonButton } from 'components/common/Forms/Button';
import { Loading } from 'components/common/Loading';
import { useAuth } from 'context/AuthContext';
import { useMutateCancelApptWithConfirm } from 'hooks/appointments/useMutateCancelApptWithConfirm';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { useUserAppointments } from 'query/appointments';
import { successToast } from 'utils/toast';
import { AppointmentItemCommon } from './AppointmentItemCommon';
import { AppointmentItem, AppointmentItemRight } from './MyAppointments.styled';
import { NoAppointmentsBar } from './NoAppointmentsBar';

import { USER_APPOINTMENTS_TYPES_BOOKED } from '../../../utils/appointmentUtil';
import { Appointment } from '../../../types/appointments';
import { useCallback } from 'react';
import { useSite } from '../../../context/SiteContext';

export const BookedAppointmentsList = () => {
  const { t } = useCommonTranslation();
  const { sangixUser } = useAuth();
  const { activeSite, setActiveSiteById } = useSite();
  const { data, isFetching } = useUserAppointments(
    USER_APPOINTMENTS_TYPES_BOOKED,
    sangixUser?.id,
  );
  const { cancelWithConfirm, isLoading: isCancelling } =
    useMutateCancelApptWithConfirm({
      onSuccess: () => successToast(t('appointment-cancel-successful')),
    });

  const cancelAppointmentWithSiteSwitch = useCallback(
    async (appointment: Appointment) => {
      if (activeSite.id !== appointment.site_id) {
        await setActiveSiteById(appointment.site_id);
      }
      cancelWithConfirm(appointment.id);
    },
    [activeSite.id, cancelWithConfirm, setActiveSiteById],
  );

  const list = data || [];
  const isLoading = isCancelling || isFetching;

  return (
    <div>
      {isLoading && <Loading />}
      {!isLoading && list.length === 0 && (
        <NoAppointmentsBar text={t('my-appointments-empty')} />
      )}
      {list.map((appt) => (
        <AppointmentItem key={appt.id}>
          <AppointmentItemCommon appt={appt} />
          <AppointmentItemRight>
            {appt.status === 'BOOKED' && (
              <CommonButton
                variant="danger"
                size="standard"
                onClick={() => cancelAppointmentWithSiteSwitch(appt)}
              >
                {t('cancel')}
              </CommonButton>
            )}
          </AppointmentItemRight>
        </AppointmentItem>
      ))}
    </div>
  );
};
